import { ContactRoleProducerSchema, } from '@eigtech/contacts-types';
import { getCornKernels } from '@eigtech/shared-corn';
import { isBookCorn, makeGlobalBookCorn } from '../corn/index.js';
export const isGlobalBookId = (bookId) => isBookCorn(bookId) &&
    ContactRoleProducerSchema.options.includes(getCornKernels(bookId).resourceId);
const globalBookIdFromRoleMap = {
    agent: undefined,
    approver: makeGlobalBookCorn('projectManager'),
    carrier: makeGlobalBookCorn('carrier'),
    coordinator: makeGlobalBookCorn('csr'),
    csr: makeGlobalBookCorn('csr'),
    deskAdjuster: makeGlobalBookCorn('deskAdjuster'),
    dispatcher: undefined,
    fieldAdjuster: makeGlobalBookCorn('fieldAdjuster'),
    fieldTechnician: makeGlobalBookCorn('fieldTechnician'),
    fileReviewer: makeGlobalBookCorn('reviewer'),
    inspectionTechnician: makeGlobalBookCorn('fieldAdjuster'),
    legalRepresentation: undefined,
    mortgageHolder: undefined,
    other: undefined,
    otherClaimContact: undefined,
    otherContact: undefined,
    policyHolder: undefined,
    primaryClaimContact: undefined,
    primaryContact: undefined,
    projectManager: makeGlobalBookCorn('projectManager'),
    propertyAccessContact: undefined,
    qa: makeGlobalBookCorn('reviewer'),
    reviewer: makeGlobalBookCorn('reviewer'),
    subcontractor: makeGlobalBookCorn('subcontractor'),
    thirdPartyClaimant: undefined,
};
export const getGlobalBookIdFromRole = (role) => globalBookIdFromRoleMap[role];
